module.exports = __webpack_public_path__ + "img/widgets6.8845450d.png";